import React from 'react';
import * as d3 from '../../libraries/d3.js';
import DateHelper from '../DateHelper/DateHelper';

export default class BottomXAxis extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    };
  };

  componentDidMount() {

    var XAxisGenerator = d3.axisBottom()
      .scale(this.props.xScale);

    var xAxis = this.props.bounds().append('g')
      .call(XAxisGenerator
        .tickFormat(d => this.props.tickFormat === 'character' ? d : DateHelper.printDateToScreen(d, this.props.date_format)))
        .attr('class', `x-axis-${this.props.report_details.id}`);

    xAxis.style('transform', `translate(0, ${this.props.yMaxMinDetailndValue.min > 0 ? this.props.dimensions().boundedHeight : this.props.yScale(0)}px)`)
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("transform", "rotate(-65)");

    var xAxisLabel = xAxis.append('text')
      .attr('class', `x-axis-label x-axis-label=${this.props.report_details.id}`)
      .attr('fill', 'black')
      .style('font-size', '1.4em')
      .html(`${this.props.report_details.x_label}`);

    xAxisLabel.style('transform', `translate(${this.props.dimensions().width / 2}px, ${100}px)`)
  };

  componentDidUpdate(prevProps) {
    let xScale = this.setXScale();
    let yScale = this.setYScale();


    var XAxisGenerator = d3.axisBottom()
      .scale(xScale);

    var t = d3.transition()
      .duration(750)
      .ease(d3.easeLinear)

    var xAxis = d3.select(`.x-axis-${this.props.report_details.id}`)

    xAxis
      .transition(t)
      .call(XAxisGenerator
        .tickFormat(d => this.props.tickFormat === 'character' ? d : DateHelper.printDateToScreen(d, this.props.date_format)))
      .style('transform', `translate(0, ${this.props.yMaxMinDetailndValue.min > 0 ? this.props.dimensions().boundedHeight : yScale(0)}px)`)
        .selectAll("text")
        .style("text-anchor", "end")
        .attr("transform", "rotate(-65)")
  };

  render() {
    return (
      null
    );
  };

  setXScale = () => {
    if (this.props.chartType === 'LineChart' || this.props.chartType === 'AreaChart' || this.props.chartType === 'DualAxisLineChart'){
      return d3.scaleTime().domain(d3.extent(this.props.data, (d) => DateHelper.parseDate(d[this.props.xAxisDetail.data_column_name], this.props.date_format))).nice().range([0, this.props.dimensions().boundedWidth])
    } else if (this.props.chartType == 'VerticalBar') {
      return d3.scaleBand().domain(this.props.data.map(d => d[this.props.xAxisDetail ? this.props.xAxisDetail.data_column_name : this.props.yAxisDetail.data_column_name])).range([0, this.props.dimensions().boundedWidth]).padding(0.2)
    };
  };

  setYScale = () => {
    if (this.props.chartType === 'LineChart' || this.props.chartType === 'AreaChart' || this.props.chartType == 'VerticalBar' || this.props.chartType == 'DualAxisLineChart'){
      return this.props.yDataType == 'percent' ? d3.scaleLinear().domain([0, 100]).nice().range([this.props.dimensions().boundedHeight, 0]) : d3.scaleLinear().domain([this.props.yMaxMinDetailndValue.min, this.props.yMaxMinDetailndValue.max]).nice().range([this.props.dimensions().boundedHeight, 0])
    };
  };

};